import { isPlatformBrowser } from '@angular/common'
import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import { WindowRef } from '@spartacus/core'
import { CarContent } from '@app/custom/services/content/content-integration.service'

function _window (): CarharttWindow {
  return window as unknown as CarharttWindow
}

function SSRLocalStorage (): Storage {
  return {
    getItem: () => '',
    setItem: () => {},
    clear: () => {},
    removeItem: () => {},
    key: () => '',
    length: 0
  }
}

@Injectable({
  providedIn: 'root'
})
export class WindowService {
  constructor (
    @Inject(PLATFORM_ID) protected platformId: object,
    protected windowRef: WindowRef
  ) {}

  get nativeWindow (): CarharttWindow {
    if (isPlatformBrowser(this.platformId)) {
      return _window()
    } else {
      return <CarharttWindow> this.windowRef.nativeWindow ?? {}
    }
  }

  get localStorage (): Storage {
    if (isPlatformBrowser(this.platformId)) {
      return this.windowRef.nativeWindow?.localStorage ?? SSRLocalStorage()
    } else {
      return SSRLocalStorage()
    }
  }

  get isPlatformBrowser (): boolean {
    return isPlatformBrowser(this.platformId)
  }

  get document (): Document {
    if (this.isPlatformBrowser) {
      return this.nativeWindow.document
    } else {
      return {} as Document
    }
  }

  public focusFirst (): void {
    const focusable = this.nativeWindow?.document.querySelector('main') as HTMLElement

    if (focusable !== null) {
      this.nativeWindow?.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      focusable.focus({preventScroll: true})
    }
  }

  public scrollToSlot (slotName: string, done: () => void = () => {}): void {
    const slotElement = this.nativeWindow?.document?.querySelector('cx-page-slot.' + slotName) as HTMLElement
    const scrollOpts = { behavior: 'smooth', block: 'start' } as ScrollIntoViewOptions
    if (!slotElement) {
      return
    }

    if (slotElement.classList.contains('cx-pending')) {
      slotElement.scrollIntoView(scrollOpts)
      let intervalCount = 0
      const loadedInterval = setInterval(() => {
        if (intervalCount >= 80) {
          clearInterval(loadedInterval)
        }
        if (!slotElement.classList.contains('cx-pending')) {
          slotElement.scrollIntoView(scrollOpts)
          clearInterval(loadedInterval)
          done()
        }
        intervalCount++
      }, 25)
    } else {
      done()
    }
  }
}

export interface CarharttWindow extends Window {
  AfterPay?: unknown;
  ApplePaySession?: unknown;
  google?: unknown;
  presentAfterpay?: unknown;
  Pixlee?: unknown;
  encodeURI?: unknown;
  carContent: CarContent;
  ak_chlge?: any;
}
